import React, { useState } from 'react';
import { observer, useLocalObservable } from 'mobx-react-lite';

const McpError = observer((props) => {
  const {
    className = '',
    title = '调用工具失败',
  } = props;

  return (
    <div className={`flex flex-col h-400px items-center justify-center ${className}`}>
      <img
        className="w-190px"
        src="https://p5.ssl.qhimg.com/t11098f6bcda6a604f3f799138d.png"
      />
      <div className="text-14px leading-30px text-black text-opacity-50">
        {title}
      </div>
    </div>
  )
});
export default McpError;